document.addEventListener('DOMContentLoaded', function() {
  var isHome = (window.location.pathname === '/' || window.location.pathname === '/index.html');

  const header = document.querySelector('header');
  if (!header) return;

  const mobileHeader = header.querySelector('.lg\\:hidden');
  const desktopHeader = header.querySelector('.lg\\:block');
  if (!mobileHeader || !desktopHeader) return;

  const mobileContainer = mobileHeader.querySelector('.flex.items-center');
  const desktopContainer = desktopHeader.querySelector('.grid');
  const logos = header.querySelectorAll('img');

  function updateHeader() {
    const scrolled = window.scrollY > 100;
    const isMobile = window.innerWidth < 1024;

    if (isHome && !scrolled) {
      mobileHeader.style.backgroundColor = 'transparent';
      desktopHeader.style.backgroundColor = 'transparent';
      desktopHeader.classList.add('gradient-blur-header');
    } else {
      mobileHeader.style.backgroundColor = '#001689';
      desktopHeader.style.backgroundColor = '#001689';
      desktopHeader.classList.remove('gradient-blur-header');
    }

    if (scrolled) {
      mobileContainer.style.paddingTop = '0.75rem';
      mobileContainer.style.paddingBottom = '0.75rem';
      desktopContainer.style.height = '7rem';

      logos.forEach(function(logo) {
        logo.style.height = isMobile ? '68px' : '90px';
      });
    } else {
      mobileContainer.style.paddingTop = '1rem';
      mobileContainer.style.paddingBottom = '1rem';
      desktopContainer.style.height = '7rem';

      logos.forEach(function(logo) {
        logo.style.height = isMobile ? '68px' : '90px';
      });
    }
  }

  updateHeader();
  window.addEventListener('scroll', updateHeader, { passive: true });
  window.addEventListener('resize', updateHeader, { passive: true });
});

// === ЛОГИКА МОБИЛЬНОГО МЕНЮ (СПРАВА + СТРАНЫ) ===
document.addEventListener('DOMContentLoaded', function() {
  // 1. Собираем ссылки основного меню с десктопной версии
  const desktopNavs = document.querySelectorAll('.lg\\:block nav a, .lg\\:block nav button.country-menu-trigger');
  let mainMenuItems = [];

  desktopNavs.forEach(link => {
    // Skip cart icon links — their textContent is just the item count number
    if (link.classList.contains('gorilla-header-cart')) return;

    const href = link.getAttribute('href') || link.getAttribute('data-href') || '#';
    // Если это кнопка Country или ссылка на #country, помечаем
    const isCountryTrigger = href === '#country' || link.classList.contains('country-menu-trigger') || link.textContent.trim().toLowerCase().includes('country');

    const text = link.textContent.trim();

    if (text) {
      mainMenuItems.push({
        href: isCountryTrigger ? '#country' : href,
        text: text,
        isCountry: isCountryTrigger
      });
    }
  });
  

  // 2. Получаем ссылки стран (переданные из header.liquid)
  const countryItems = window.countryMenuItems || [];

  // 3. Создаем HTML оболочку (ПРАВАЯ СТОРОНА)
  // Добавлены классы: .mobile-menu-overlay, .mobile-menu-panel, .mobile-menu-close, .mobile-menu-nav
  const menuWrapperHTML = `
    <div id="mobile-menu-overlay" class="mobile-menu-overlay" style="display: none;">
      <div id="mobile-menu-panel" class="mobile-menu-panel">
        <button id="mobile-menu-close" class="mobile-menu-close" aria-label="Close menu">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="mobile-menu-close-icon">
            <path d="M18 6 6 18"></path><path d="m6 6 12 12"></path>
          </svg>
        </button>
        <nav id="mobile-menu-nav" class="mobile-menu-nav">
          </nav>
      </div>
    </div>
  `;

  // Вставляем оболочку, если ее еще нет
  if (!document.getElementById('mobile-menu-overlay')) {
    document.body.insertAdjacentHTML('beforeend', menuWrapperHTML);
  }

  // Элементы DOM
  const menuToggleButton = document.querySelector('header button[aria-label="Toggle menu"]') || document.getElementById('mobile-menu-trigger-btn');
  const overlay = document.getElementById('mobile-menu-overlay');
  const panel = document.getElementById('mobile-menu-panel');
  const closeButton = document.getElementById('mobile-menu-close');
  const navContainer = document.getElementById('mobile-menu-nav');

  if (!menuToggleButton) return;

  // --- ФУНКЦИИ РЕНДЕРИНГА ---

  function renderMain() {
    const html = mainMenuItems.map((item, index) => {
      const isLast = index === mainMenuItems.length - 1;
      const extraClass = isLast ? 'mobile-menu-link--last' : '';
      const countryClass = item.isCountry ? 'js-country-trigger' : '';
      const isTryNow = item.text.toLowerCase() === 'try now';
      const btnClass = isTryNow ? 'mobile-menu-btn' : '';

      return `<a href="${item.href}" class="mobile-menu-link ${btnClass} ${extraClass} ${countryClass}">${item.text}</a>`;
    }).join('');
    
    navContainer.innerHTML = html;
    attachLinkListeners(); // Переназначаем обработчики
  }

  function renderCountry() {
    // Кнопка "Назад" с классом .mobile-menu-back
    let html = `
      <button id="js-back-menu" class="mobile-menu-back">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" class="mobile-menu-back-icon"><path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" /></svg>
        Back
      </button>
    `;

    html += countryItems.map((item) => {
      // Ссылки стран используют тот же класс .mobile-menu-link
      return `<a href="${item.url}" target="_blank" class="mobile-menu-link">${item.title}</a>`;
    }).join('');

    navContainer.innerHTML = html;
    
    // Обработчик кнопки "Назад"
    const backBtn = document.getElementById('js-back-menu');
    if(backBtn) {
        backBtn.addEventListener('click', function(e) {
          e.preventDefault();
          renderMain();
        });
    }
  }

  function attachLinkListeners() {
    // Обработка клика по "Select Country"
    const countryLinks = navContainer.querySelectorAll('.js-country-trigger, a[href="#country"]');
    countryLinks.forEach(link => {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation(); // Важно, чтобы не сработал глобальный закрыватель
        renderCountry();
      });
    });

    // Обработка обычных ссылок (закрытие меню)
    const normalLinks = navContainer.querySelectorAll('.mobile-menu-link:not(.js-country-trigger):not([href="#country"])');
    normalLinks.forEach(link => {
      link.addEventListener('click', function() {
         // Если это якорная ссылка на этой же странице
         const href = this.getAttribute('href');
         if (href && href.includes('#')) closeMenu();
      });
    });
  }

  // --- ФУНКЦИИ ОТКРЫТИЯ/ЗАКРЫТИЯ ---

  function openMenu() {
    renderMain(); // Всегда начинаем с главного меню
    overlay.style.display = 'block';
    document.body.style.overflow = 'hidden';
    
    // Используем requestAnimationFrame для плавного старта анимации
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        overlay.classList.add('is-visible'); // Добавляем класс для opacity
        panel.classList.add('is-open');      // Добавляем класс для transform
      });
    });
  }

  function closeMenu() {
    overlay.classList.remove('is-visible');
    panel.classList.remove('is-open');
    document.body.style.overflow = '';
    
    // Ждем окончания transition (300ms) перед скрытием display: none
    setTimeout(() => {
      overlay.style.display = 'none';
    }, 300);
  }

  // --- ГЛОБАЛЬНЫЕ СЛУШАТЕЛИ ---

  menuToggleButton.addEventListener('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    openMenu();
  });

  closeButton.addEventListener('click', function(e) {
    e.preventDefault();
    closeMenu();
  });

  overlay.addEventListener('click', function(e) {
    if (e.target === overlay) closeMenu();
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && overlay.style.display === 'block') closeMenu();
  });
  
  // Обработка клика по "Select Country" в ДЕСКТОПНОМ хедере
  document.body.addEventListener('click', function(e) {
      const link = e.target.closest('a[href="#country"], button.country-menu-trigger');
      // Проверяем, что клик был НЕ внутри мобильного меню (чтобы не зациклить)
      if (link && !link.closest('#mobile-menu-panel')) {
         e.preventDefault();
         openMenu(); // Открываем панель
         setTimeout(() => renderCountry(), 50); // И переключаем на страны
      }
  });
});

// === RECHARGE CART DRAWER — SHADOW DOM STYLE INJECTION ===
// ReCharge's storefront-experiences widget renders inside a shadow root,
// so external CSS cannot reach it. We inject brand styles directly into
// each shadow root we find under the ReCharge containers.
(function () {
  var RC_BRAND_CSS = [
    /* Override the confirmed --storefront-drawer-* custom properties on the shadow host.
       These drive all Tailwind utility classes inside the widget (bg-storefront-drawer-primary, etc.) */
    ':host {',
    '  --storefront-drawer-primary:            rgb(13, 175, 31) !important;',
    '  --storefront-drawer-primary-foreground: #ffffff !important;',
    '  --storefront-drawer-secondary:          #E3EBF0 !important;',
    '  --storefront-drawer-secondary-foreground: rgb(0, 22, 137) !important;',
    '  --storefront-drawer-accent:             rgb(13, 175, 31) !important;',
    '  --storefront-drawer-accent-foreground:  #ffffff !important;',
    '  --storefront-drawer-link:               rgb(0, 22, 137) !important;',
    '  --storefront-drawer-ring:               rgb(13, 175, 31) !important;',
    '  --storefront-drawer-radius:             9999px !important;',
    '}',

    '* { font-family: "DIN 2014 Bold", "DIN 2014", system-ui, sans-serif !important; }',

    'h1, h2, h3, h4 {',
    '  color: rgb(0, 22, 137) !important;',
    '  text-transform: uppercase !important;',
    '  letter-spacing: 0.02em !important;',
    '}',

    'button {',
    '  font-family: "DIN 2014 Bold", "DIN 2014", system-ui, sans-serif !important;',
    '  font-weight: 700 !important;',
    '  text-transform: uppercase !important;',
    '  letter-spacing: 0.05em !important;',
    '  cursor: pointer !important;',
    '}',

    /* Primary / checkout / CTA buttons — match site .checkout-btn exactly */
    '[class*="checkout"], [class*="button--primary"], [class*="btn--primary"],',
    '[class*="primary-button"], [class*="cta"],',
    '[class*="empty-cart"][class*="btn"], [class*="empty-cart"][class*="button"],',
    '[class*="empty_cart"][class*="btn"], [class*="empty_cart"][class*="button"] {',
    '  display: block !important;',
    '  width: 100% !important;',
    '  background-color: rgb(13, 175, 31) !important;',
    '  border: none !important;',
    '  border-radius: 50px !important;',
    '  color: #ffffff !important;',
    '  padding: 16px !important;',
    '  font-size: 18px !important;',
    '  font-weight: 700 !important;',
    '  text-transform: uppercase !important;',
    '  text-align: center !important;',
    '  text-decoration: none !important;',
    '  letter-spacing: 0.05em !important;',
    '  box-shadow: 0 4px 15px rgba(13, 175, 31, 0.3) !important;',
    '  transition: transform 0.1s, opacity 0.2s !important;',
    '  cursor: pointer !important;',
    '}',

    '[class*="checkout"]:hover, [class*="button--primary"]:hover,',
    '[class*="btn--primary"]:hover, [class*="cta"]:hover {',
    '  opacity: 0.9 !important;',
    '  transform: translateY(-2px) !important;',
    '}',

    /* Quantity +/- buttons */
    '[class*="quantity"] button, [class*="qty"] button, [class*="stepper"] button {',
    '  background: transparent !important;',
    '  color: rgb(0, 22, 137) !important;',
    '  border: none !important;',
    '  border-radius: 0 !important;',
    '  box-shadow: none !important;',
    '}',

    /* Quantity wrapper */
    '[class*="quantity-selector"], [class*="quantity-wrapper"],',
    '[class*="qty-wrapper"], [class*="stepper-wrapper"] {',
    '  border-radius: 50px !important;',
    '  overflow: hidden !important;',
    '  border: 1px solid #ddd !important;',
    '  background: #f4f4f4 !important;',
    '}',

    /* Links */
    'a { color: rgb(0, 22, 137) !important; }',

    /* Savings / discount badges */
    '[class*="saving"], [class*="discount"], [class*="badge"] {',
    '  color: rgb(13, 175, 31) !important;',
    '  font-weight: 700 !important;',
    '}',

    /* Shipping progress bar fill */
    '[class*="progress"] [class*="bar"], [class*="progress-fill"],',
    '[class*="progress-bar--fill"], [class*="progress__bar"] {',
    '  background-color: rgb(13, 175, 31) !important;',
    '}',

    /* Cart item product image — override Tailwind w-20 h-20 (80px) */
    '[role="listitem"] img {',
    '  width: 50px !important;',
    '  height: auto !important;',
    '}'
  ].join('\n');

  var injected = new WeakSet();

  function injectIntoShadow(shadowRoot) {
    if (!shadowRoot || injected.has(shadowRoot)) return;
    injected.add(shadowRoot);
    var style = document.createElement('style');
    style.textContent = RC_BRAND_CSS;
    shadowRoot.appendChild(style);
  }

  function scanForShadowRoots() {
    var roots = [
      document.getElementById('recharge-storefront-experiences'),
      document.getElementById('recharge-storefront-experiences__cart-drawer'),
      document.getElementById('recharge-storefront-experiences__cart-overlay')
    ];

    roots.forEach(function (host) {
      if (!host) return;
      // Check the host itself
      if (host.shadowRoot) injectIntoShadow(host.shadowRoot);
      // Check all descendants (ReCharge may nest shadow hosts)
      host.querySelectorAll('*').forEach(function (el) {
        if (el.shadowRoot) injectIntoShadow(el.shadowRoot);
      });
    });
  }

  // Watch for ReCharge elements being added or mutated.
  // Each mutation triggers an immediate scan + a delayed retry, because
  // ReCharge attaches shadow roots imperatively *after* inserting the host
  // element — so the shadow root isn't visible at mutation time.
  var observer = new MutationObserver(function () {
    scanForShadowRoots();
    setTimeout(scanForShadowRoots, 150);
    setTimeout(scanForShadowRoots, 500);
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });

  // Poll for 4 seconds on page load to catch lazily-attached drawer shadow root
  var rcPoll = 0;
  (function poll() {
    scanForShadowRoots();
    if (++rcPoll < 20) setTimeout(poll, 200);
  })();

  window.addEventListener('load', scanForShadowRoots);

  // The cart OVERLAY is an upsell popup whose shadow root is only created on the
  // first add-to-cart action. Scan after any click (add-to-cart requires clicking)
  // so we catch the overlay shadow root regardless of what URL ReCharge uses.
  document.addEventListener('click', function () {
    setTimeout(scanForShadowRoots, 400);
    setTimeout(scanForShadowRoots, 900);
    setTimeout(scanForShadowRoots, 2000);
  }, true);

  // Also wrap fetch to catch /cart/add as a fallback.
  var _rcOrigFetch = window.fetch;
  window.fetch = function () {
    var result = _rcOrigFetch.apply(this, arguments);
    var url = typeof arguments[0] === 'string'
      ? arguments[0]
      : (arguments[0] && arguments[0].url) || '';
    if (url && (url.indexOf('/cart/add') !== -1 || url.indexOf('rechargeapps') !== -1)) {
      result.then(function () {
        setTimeout(scanForShadowRoots, 300);
        setTimeout(scanForShadowRoots, 800);
        setTimeout(scanForShadowRoots, 1500);
      });
    }
    return result;
  };
})();